import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";
import { Link as LinkS } from "react-scroll";
import { purple } from "../../constants/index";

export const Nav = styled.nav`
  padding-top: 30px;
  padding-bottom: 80px;
  background: "transparent";
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 1023px) {
    transition: 0.8s all ease;
    padding-top: 10px;
    padding-bottom: 40px;
  }
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  z-index: 1;
  width: 100%;
`;

export const NavLogo = styled(LinkR)`
  color: #fff;
  justify-self: flex-start;
  cursor: pointer;
  font-size: 40px;
  display: flex;
  font-weight: bold;
  text-decoration: none;
  font-weight: 600;

  @media screen and (max-width: 766px) {
    font-size: 32px;
  }
`;

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 1023px) {
    display: block;
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 32px;
    cursor: pointer;
    color: #fff;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-right: -22px;

  @media screen and (max-width: 1023px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  display: flex;
`;

export const NavLinks = styled(LinkS)`
  color: #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 30px;
  height: 100%;
  cursor: pointer;
  font-size: 20px;
  font-weight: 400;

  &.active {
    border-bottom: 3px solid #01bf71;
  }

  &:hover {
    color: ${purple};
    transition: 0.3s all ease;
  }
`;
